import { render } from "./CareerDetail.vue?vue&type=template&id=7cfe428d&scoped=true"
import script from "./CareerDetail.vue?vue&type=script&lang=ts"
export * from "./CareerDetail.vue?vue&type=script&lang=ts"

import "./CareerDetail.vue?vue&type=style&index=0&id=7cfe428d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7cfe428d"

export default script